<template>
  <div>
    <Head title="Assessments" />
    <h1 class="mb-8 text-3xl font-bold">
      Transaksi
      <span class="text-indigo-400 font-medium"> / </span>
      Assessment
    </h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter
        v-model="form.search"
        :show-dropdown="false"
        class="mr-4 w-full max-w-md"
        @reset="reset" />
      <Link class="btn-indigo" href="/assessments/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Assessment</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">
              Code
            </th>
            <th class="pb-4 pt-6 px-6">
              Status
            </th>
            <th class="pb-4 pt-6 px-6">
              Jenis Bantuan
            </th>
            <th class="pb-4 pt-6 px-6 text-right">
              Jumlah Paket
            </th>
            <th class="pb-4 pt-6 px-6 text-right">
              Beneficiaries
            </th>
            <th class="pb-4 pl-6 pr-14 pt-6" colspan="2">
              Description
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="d in assessments.data"
            :key="d.id"
            class="focus-within:bg-gray-100 hover:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/assessments/${d.id}/edit`">
                {{ d.code }}
                <icon
                  v-if="d.deleted_at"
                  name="trash"
                  class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4 font-bold"
                :href="`/assessments/${d.id}/edit`"
                tabindex="-1">
                {{ d.assessment_status }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/assessments/${d.id}/edit`"
                tabindex="-1">
                {{ d.donation_type }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center justify-end px-6 py-4"
                :href="`/assessments/${d.id}/edit`"
                tabindex="-1">
                {{ d.paket_qty }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center justify-end px-6 py-4"
                :href="`/assessments/${d.id}/edit`"
                tabindex="-1">
                {{ d.total_qty_beneficiaries }}
              </Link>
            </td>
            <td class="whitespace-normal border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/assessments/${d.id}/edit`"
                tabindex="-1">
                {{ d.desc }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link
                class="flex items-center px-4"
                :href="`/assessments/${d.id}/edit`"
                tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="assessments.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="7">
              No assessments found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="assessments.links" />
  </div>
</template>

<script lang="js">
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
    components: {
        Head,
        Icon,
        Link,
        Pagination,
        SearchFilter,
    },
    layout: Layout,
    props: {
        filters: Object,
        assessments: Object,
    },
    data () {
        return {
            form: {
                search: this.filters.search,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/assessments', pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        reset () {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
